// extracted by mini-css-extract-plugin
module.exports = {"footer_buttons_container":"footer-mobile_footer_buttons_container__LUTcr","footer_buttons_drawer_list":"footer-mobile_footer_buttons_drawer_list__L61B8"};